import { jsx as _jsx } from "react/jsx-runtime";
import { Slide } from '@mui/material';
import NavLink from '../NavLink/NavLink';
const MobileNavQuickLinks = (props) => {
    const { quickLinks, navDirection, iconPosition, onLinkSelection } = props;
    return (_jsx(Slide, { direction: navDirection, in: true, children: _jsx("ul", { children: quickLinks.map((link) => link.label ? (_jsx(NavLink, Object.assign({}, link, { onClick: link.url ? () => onLinkSelection(link.label) : undefined, isFromMegaNavMobile: true, quickLinkIconPosition: iconPosition, isFromQuickLinks: true }), link.label)) : null) }) }));
};
export default MobileNavQuickLinks;
